"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Image = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importStar(require("react"));

var root_1 = require("./styled/root");

var Image = function Image(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      _b = _a.alt,
      alt = _b === void 0 ? '' : _b,
      className = _a.className,
      isRound = _a.isRound,
      src = _a.src,
      ratio = _a.ratio,
      _c = _a.fit,
      fit = _c === void 0 ? 'cover' : _c,
      rest = tslib_1.__rest(_a, ["__UIScope", 'data-testid', "alt", "className", "isRound", "src", "ratio", "fit"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Image',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  var _d = tslib_1.__read((0, react_1.useState)(true), 2),
      isLoading = _d[0],
      setIsLoading = _d[1];

  var transformRatio = function transformRatio(ratio) {
    return ratio === null || ratio === void 0 ? void 0 : ratio.replace(':', ' / ');
  };

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    className: rootClasses,
    "data-testid": testID,
    alt: alt,
    src: src,
    isRound: isRound,
    isLoading: isLoading,
    onLoad: function onLoad() {
      return setIsLoading(false);
    },
    ratio: transformRatio(ratio),
    fit: fit
  }, rest));
};

var ImageWithSpace = (0, ui_helper_with_space_1.withSpace)(Image);
exports.Image = ImageWithSpace;